<script>
import Vue from "vue";

export default Vue.extend({
	name: "OptionsDropdown",
	props: {
		buttonLabel: String,
		title: String,
		theme: String,
		resetOptions: Function,
	},
	data() {
		return {
			hideOptions: true,
		}
	},
	computed: {
		classList() {
			return {
				"dark-theme": this.theme === "dark-theme",
				"light-theme": this.theme === "light-theme",
				hidden: this.hideOptions,
			}
		},
	},
	methods: {
		onCloseOptions() {
			if (!this.hideOptions) {
				this.hideOptions = true;
			}
		},
		onCancelOptions() {
			if (!this.hideOptions) {
				this.hideOptions = true;
				if (this.resetOptions) {
					this.resetOptions();
				}
			}
		},
		onToggleOptions() {
			if (!this.hideOptions) {
				this.onCancelOptions();
			} else {
				this.hideOptions = false;
			}
		},
	},
});
</script>

<template>
	<div class="dropdown-options" :class="theme" v-click-outside="onCancelOptions">
		<BaseButton class="button-secondary" :theme="theme" @click.prevent="onToggleOptions()">{{buttonLabel}}</BaseButton>
		<div class="dropdown-area" :class="classList">
			<h4>{{title}}</h4>
			<div @click.prevent="onCancelOptions()" class="close"></div>
			<slot></slot>
		</div>
	</div>
</template>

<style lang="less" scoped>
@import (reference) "../assets/variables.less";

.dropdown-options {
	background-color: inherit;
	& > button {
		margin: 0 0 0 @gap-small;
	}
}

.dropdown-area {
	position: absolute;
	right: 0;
	padding: @gap-medium @gap-medium;
	margin: @gap-small @gap-small 0;
	background-color: @ui-light-1;
	border: 1px solid @ui-light-5;
	border-radius: @border-radius;
	.dark-theme & {
		background-color: @ui-dark-1;
		border-color: @ui-dark-5;
	}
}

.close {
	cursor: pointer;
	position: absolute;
	font-weight: @weight-bold;
	top: 0;
	right: 0;
	color: inherit;
	padding: @gap-smallest @gap-small;
	&:before {
		content: '\2715';
	}
}

h4 {
	margin-bottom: @gap-smallest;
	text-align: center;
}

.option-row {
	display: flex;
	justify-content: space-between;
	button {
		margin: @gap-small;
		width: 100%;
		min-width: 100px;
	}
}

.label {
	display: inline-block;
	min-width: 160px;
	margin: auto @gap-smallest;
}

.option {
	display: inline-block;
	width: 160px;
	margin: 0 @gap-smallest;
}

.button-group {
	margin-top: @gap-small;
}
button {
	margin: @gap-small;
}
</style>
